import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { customLoaderFactory } from './core/http/translation.loader';
import { provideIcons } from './core/icons/icons.provider';
import { provideLuxon, provideRmsLuxonDateAdapter } from './core/luxon/luxon.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: environment.defaultLanguage },
    importProvidersFrom(
      BrowserModule,
      MatDialogModule,
      TranslateModule.forRoot({
        fallbackLang: environment.defaultLanguage,
        loader: { provide: TranslateLoader, useFactory: customLoaderFactory },
      })
    ),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, disableClose: true, closeOnNavigation: true, autoFocus: false },
    },
    // Previously supplied by provideVex(); Material defaults to 'fill' without it.
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    provideAnimations(),
    provideHttpClient(),
    provideIcons(),
    provideLuxon(),
    provideRmsLuxonDateAdapter(),
  ],
};
